import { IntlShape } from "react-intl";
import { createColumnHelper, ColumnDef } from "types/common/Header";
import { Vendor } from "./models/response/get-vendors-response";
import { VENDOR_SORT_KEYS } from "./vendor.constants";

const columnHelper = createColumnHelper<Vendor>();

export const getVendorHeaders = (intl: IntlShape): ColumnDef<Vendor>[] => [
  columnHelper.accessor("name", {
    displayName: intl.formatMessage({ id: "baseTable.name" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.NAME,
    alignRight: false,
    cell: (row) => <span>{row.name}</span>,
  }),
  columnHelper.accessor("contactName", {
    displayName: intl.formatMessage({ id: "baseTable.contactName" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.CONTACT_NAME,
    alignRight: false,
    cell: (row) => <span>{row.contactName}</span>,
  }),
  columnHelper.accessor("address", {
    displayName: intl.formatMessage({ id: "baseTable.address" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.ADDRESS,
    alignRight: false,
    cell: (row) => <span>{row.address}</span>,
  }),
  columnHelper.accessor("city", {
    displayName: intl.formatMessage({ id: "baseTable.city" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.CITY,
    alignRight: false,
    cell: (row) => <span>{row.city}</span>,
  }),
  columnHelper.accessor("state", {
    displayName: intl.formatMessage({ id: "baseTable.state" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.STATE,
    alignRight: false,
    cell: (row) => <span>{row.state}</span>,
  }),
  columnHelper.accessor("country", {
    displayName: intl.formatMessage({ id: "country" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.COUNTRY,
    alignRight: false,
    cell: (row) => <span>{row.country?.name}</span>,
  }),
  columnHelper.accessor("zip", {
    displayName: intl.formatMessage({ id: "baseTable.zip" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.ZIP,
    alignRight: false,
    cell: (row) => <span>{row.zip}</span>,
  }),
  columnHelper.accessor("phone", {
    displayName: intl.formatMessage({ id: "baseTable.phone" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.PHONE,
    alignRight: false,
    cell: (row) => <span>{row.phone}</span>,
  }),
  columnHelper.accessor("email", {
    displayName: intl.formatMessage({ id: "baseTable.email" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.EMAIL,
    alignRight: false,
    cell: (row) => <span>{row.email}</span>,
  }),
  columnHelper.accessor("industrySpecialist.name", {
    displayName: intl.formatMessage({ id: "usAdmin.industrySpecialist" }),
    sortable: true,
    sortKey: VENDOR_SORT_KEYS.INDUSTRY_SPECIALIST,
    alignRight: false,
    cell: (row) => <span>{row.industrySpecialist?.name || "N/A"}</span>,
  }),
];
